/**
 * Create a map pin marker element (button) with an SVG teardrop shape.
 * The icon is applied via CSS background-image on the .marker-pin-icon element.
 *
 * @param {string} className - CSS class for the marker type (e.g. 'marker-layer-dining')
 * @param {string} color - Fill color for the pin (e.g. '#00759b')
 * @param {string} label - Accessible label for the button
 * @returns {HTMLButtonElement}
 */
export default function createMarkerPin(className, color, label) {
	const el = document.createElement('button');
	el.className = 'marker-layer ' + className;
	el.setAttribute('aria-label', label);

	el.innerHTML =
		`<svg class="marker-pin-shape" viewBox="-1.5 -1.5 33 44" xmlns="http://www.w3.org/2000/svg">` +
		`<path d="M15 0C6.72 0 0 6.72 0 15 0 26.08 15 41 15 41S30 26.08 30 15C30 6.72 23.28 0 15 0z" fill="${color}" stroke="#fff" stroke-width="1.5"/>` +
		`</svg>` +
		`<span class="marker-pin-icon"></span>` +
		`<span class="marker-pin-label" aria-hidden="true">${label}</span>`;

	return el;
}
